import { FavoriteBtn } from '@components/FavoriteBtn';
import { getDefalutImgUrl } from '@constants/config';
import { type GemItemType, getGemTypeString } from '@constants/gemType';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { type IDicItem } from '@interface/IItemDic';
import classNames from 'classnames';
import {useTranslation} from "react-i18next";

export const DicItemLineageClassic = ({ it}: { it: IDicItem }) => {

    const getSearchType = () => {
        const path = location.pathname;
        const match = path.match(/\/info\/(\w+)/);
        return match ? match[1] : 'item';  // 기본값으로 'item' 반환
    };

    const searchType = getSearchType();

    const optionsText = (it.options ?? []).filter((op) => op.trim() !== '').join(', ');
    const descText = (it.description ?? '').trim();

    const parts = [optionsText, descText].filter(Boolean);
    const optionsDesc = parts.length ? parts.join(', ') : '-';

    const setParams = useSetSearchParams();

    const handleItemClick = () => {
        const type = searchType; // 'item', 'spell', 또는 'monster'
        setParams({ detail: `${type}_${it.id}_${it.level || 0}_0` });
    };

    const { t } = useTranslation();

    return (
        <div className={classNames({ 'has-option': optionsDesc }, 'tablerow')} data-id={it.id}>
            {searchType === 'item' && (
                <>
                    <div className="tablecell favorite">
                        <FavoriteBtn itemId={it.id} isFav={it.favorite} type={'item'} ga360str="시세_리스트_즐겨찾기_클릭" />
                    </div>
                    <div className="tablecell">
                        <button className="btn-item" onClick={handleItemClick}>
                            <img className="thumb" src={it.image} onError={(e) => (e.currentTarget.src = getDefalutImgUrl())} />
                            <strong className="name" data-itemgrade={it.grade}>
                                {it.name} {getGemTypeString(it.category2 as GemItemType)}
                            </strong>
                            {!it.tradable && <span className="tradable" title="각인" />}
                        </button>
                    </div>
                    <div className="tablecell">{it.categoryName || '-'}</div>
                    <div className="tablecell">{optionsDesc}</div>
                </>
            )}
            {searchType === 'spell' && (
                <>
                    <div className="tablecell favorite">
                        <FavoriteBtn itemId={it.id} isFav={it.favorite} type={'spell'} ga360str="시세_리스트_즐겨찾기_클릭" />
                    </div>
                    <div className="tablecell spell">
                        <button className="btn-item" onClick={handleItemClick}>
                            <img className="thumb" src={it.image} onError={(e) => (e.currentTarget.src = getDefalutImgUrl())} />
                            <strong className="name" data-itemgrade={it.grade}>
                                {it.name}
                            </strong>
                            {!it.tradable && <span className="tradable" title="각인" />}
                        </button>
                    </div>
                    <div className="tablecell">
                        {it.classNames?.length > 0
                            ? `${it.classNames.join(', ')}`
                            : t('common.all')
                        }
                    </div>
                    <div className="tablecell">
                        {it.consumables && (
                            <>
                                {(it.consumables.hp ?? 0) > 0 && <p>HP {it.consumables.hp}</p>}
                                {(it.consumables.mp ?? 0) > 0 && <p>MP {it.consumables.mp}</p>}
                                {it.consumables.itemName && <p>{it.consumables.itemName} {(it.consumables.itemCount ?? 0) > 0 && <span>{it.consumables.itemCount}개</span>}</p>}
                            </>
                        )}
                    </div>
                    <div className="tablecell">{it.duration}</div>
                    <div className="tablecell">{it.description}</div>
                </>
            )}
            {searchType === 'monster' && (
                <>
                    <div className="tablecell favorite">
                        <FavoriteBtn itemId={it.id} isFav={it.favorite} type={'monster'} ga360str="시세_리스트_즐겨찾기_클릭" />
                    </div>
                    <div className="tablecell monster">
                        <button className="btn-item" onClick={handleItemClick}>
                            <img className="thumb" src={it.image} onError={(e) => (e.currentTarget.src = getDefalutImgUrl())} />
                            <strong className="name" data-itemgrade={it.grade}>
                                {it.name} {getGemTypeString(it.category2 as GemItemType)}
                            </strong>
                            {!it.tradable && <span className="tradable" title="각인" />}
                        </button>
                    </div>
                    <div className="tablecell">
                        {it.regionNames?.length > 0
                            ? `${it.regionNames[0]}${it.regionNames.length > 1 ? ` ${t('common.except')}` : ''}`
                            : '-'
                        }
                    </div>
                    <div className="tablecell">{it?.level}</div>
                    <div className="tablecell">{it?.formName !== '' ? it?.formName : '-'}</div>
                    <div className="tablecell">
                        {it.rewordNames?.length > 0
                            ? `${it.rewordNames.join(', ')}`
                            : '-'
                        }
                    </div>
                </>
            )}
        </div>
    );
};
